import { ADMIN_SETTINGS_ENDPOINTS } from "@/config/api";
import { httpClient } from "@/lib/http";
import type { ApiResponse } from "@/types/api";

import type {
    ChangeOwnPasswordRequest,
    ChangeOwnPasswordResponse,
    CurrentAdminProfile,
} from "../types";

export const getCurrentAdminProfile = async (): Promise<ApiResponse<CurrentAdminProfile>> => {
    const { data } = await httpClient.get<ApiResponse<CurrentAdminProfile>>(
        ADMIN_SETTINGS_ENDPOINTS.ME
    );
    return data;
};

export const changeOwnPassword = async (
    payload: ChangeOwnPasswordRequest
): Promise<ApiResponse<ChangeOwnPasswordResponse>> => {
    const { data } = await httpClient.post<ApiResponse<ChangeOwnPasswordResponse>>(
        ADMIN_SETTINGS_ENDPOINTS.CHANGE_PASSWORD,
        payload
    );
    return data;
};
